const hasAtLeastOneCampaign = campaigns => {
    if(!Array.isArray(campaigns)) return false;
    return Boolean(campaigns.filter(({ selected }) => selected).length);
}

export default hasAtLeastOneCampaign;